export var FIELD_META_PROP = 'data-__meta';
export var FIELD_DATA_PROP = 'data-__field';


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/form/constants.js
// module id = 317
// module chunks = 1